import {
  faBuilding,
  faCircle,
  faClock,
  faCog,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faFileChartPie,
  faHome,
  faIdBadge,
  faIdCard,
  faInfo,
  faInfoCircle,
  faPlus,
  faQuestion,
  faSpinner,
  faSync,
  faTrash,
  faUser,
  faUserHardHat,
} from "@fortawesome/pro-solid-svg-icons";
import { configureStore, getUserManager, setClientUIConfiguration } from "@interface48/app";
import "@interface48/app/dist/assets/polyfills/cra-supplementary.js";
import blue from "@material-ui/core/colors/blue";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import { Provider } from "react-redux";
import { OidcProvider } from "redux-oidc";
import { App } from "./App";
import { ApplicationState, reducers } from "./store";

setClientUIConfiguration(
  {
    collapsedNavDrawerWidth: 0,
    theme: {
      type: "light",
      colours: {
        primary: "#0097a7",
        secondary: blue[500],
      },
    },
  },
  [
    faBuilding,
    faCircle,
    faClock,
    faCog,
    faEdit,
    faEnvelope,
    faExclamationCircle,
    faFileChartPie,
    faHome,
    faIdBadge,
    faIdCard,
    faInfoCircle,
    faInfo,
    faPlus,
    faSpinner,
    faSync,
    faTrash,
    faUser,
    faUserHardHat,
    faQuestion,
  ],
);

// Create browser history to use in the Redux store
const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState as ApplicationState;
const store = configureStore(reducers, initialState, history);

let enableAnalytics = false;
const host = window.location.host;
// If we're not in the dev or staging environment, enable GA...
if (host.indexOf("localhost") === -1 && host.indexOf("interface48.com") === -1) {
  ReactGA.initialize("UA-100377971-1");
  enableAnalytics = true;
}

const rootElement = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={getUserManager()}>
      <ConnectedRouter history={history}>
        <App enableAnalytics={enableAnalytics} />
      </ConnectedRouter>
    </OidcProvider>
  </Provider>,
  rootElement,
);
